var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item",class:{ active: _vm.active }},[_c('b-link',{staticClass:"nav-link",attrs:{"to":_vm.to}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"nav-link-icon",attrs:{"fixedWidth":"","icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }